import { getBffUrl as bffUrlSelector } from 'selectors'
import store from '../store'

import * as Api from '../utils/api'

const getBffUrl = () => bffUrlSelector(store.getState())

export const fetchAlerts = () => Api.get(
  `${getBffUrl()}/alerts`
)

export const fetchHistory = () => Api.get(
  `${getBffUrl()}/alerts/history`
)

export const createAlert = body => Api.post(
  `${getBffUrl()}/alerts`,
  body
)

export const updateAlert = (id, body) => Api.patch(
  `${getBffUrl()}/alerts/${id}`,
  body
)

export const deleteAlert = id => Api.destroy(
  `${getBffUrl()}/alerts/${id}`
)

export const previewAlert = id => Api.get(
  `${getBffUrl()}/alerts/${id}/preview`
)

export const updateAlertsStatus = (ids, enabled) => Api.patch(
  `${getBffUrl()}/alerts/bulk/status`,
  { ids, enabled }
)

export const deleteAlerts = ids => Api.destroy(
  `${getBffUrl()}/alerts/bulk`,
  { ids }
)
